<template>
  <v-layout fill-height row wrap>
    <v-layout style="height: 95vh;" fill-height row :wrap="$vuetify.breakpoint.smAndDown">
      <v-flex pa-1 xs12 grow>
        <OverwatchMap
          ref="taxiMap"
          :taxis="taxis"
          :bookings="bookings"
          :setSelectedTaxi="setSelectedTaxi"
          :customersForMap="customersForMap"
          style="height: 100%; width: 100%"
          :showCustomersInApp="true"
        ></OverwatchMap>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
// @ is an alias to /src
import Home from "@/components/Home.vue";
import OverwatchCard from "@/components/widget/OverwatchCard.vue";
import OverwatchMap from "@/components/overwatch/OverwatchMap.vue";

import TaxiList from "@/components/overwatch/TaxiList.vue";

import AssignTrip from "@/components/booking/AssignTrip.vue";

import SmallBookForm from "@/components/booking/SmallBookForm.vue";

import LargeBookForm from "@/components/booking/LargeBookForm.vue";

import UpcomingTrips from "@/components/overwatch/UpcomingTrips.vue";
import ActiveTrips from "@/components/overwatch/ActiveTrips.vue";

import { BookingForm } from "@/components/util/BookingForm.js";

import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

import moment from "moment";

global.jQuery = require("jquery");
var $ = global.jQuery;

export default {
  name: "overwatch_map",
  components: {
    Home,
    OverwatchCard,
    OverwatchMap,
    TaxiList,
    UpcomingTrips,
    ActiveTrips,
    SmallBookForm,
    LargeBookForm,
    AssignTrip
  },
  data: function() {
    return {
      lastUpdateTime: null,
      createBookingDialog: false,
      editBookingDialog: false,
      loadingEditBooking: false,
      editBookingError: null,
      actionBoxMode: null,
      loading: true,
      rideTypes: [],
      taxis: [],
      bookings: [],
      rideTypeEtas: null,
      selectedTaxi: -1,
      selectedBooking: -1,
      bookingForm: null,
      bookingToAssign: null,
      getInformationTimer: null,
      getCustomersFromMapTimer: null,
      customersForMap: []
    };
  },
  watch: {
    createBookingDialog: function(val) {
      console.log("Dialog changed " + val);

      var vm = this;
    }
  },
  created: function() {},
  beforeDestroy: function() {
    clearTimeout(this.getInformationTimer);
    this.getInformationTimer = null;

    clearTimeout(this.getCustomersFromMapTimer);
    this.getCustomersFromMapTimer = null;
  },
  mounted: function() {
    var vm = this;

    this.getCustomersFromMapTimer = setInterval(function() {
      vm.getCustomersForMap();
    }, 1000);

    this.getInformationTimer = setTimeout(function() {
      vm.getInformation();
      vm.getRideTypes();
    }, 2000);

    setTimeout(function() {
      $(document).on("click", function(e) {
        // console.log($(e.target)[0].id);
        // console.log($(e.target).attr("class"));

        var id = $(e.target)[0].id;

        if (id == "gridcontainer" || $(e.target).attr("class") == "flex") {
          // Clicked on blank space
          vm.selectedBooking = -1;
          vm.setSelectedTaxi(-1);
        }
      });
    }, 5000);
  },
  computed: {},
  methods: {
    rideTypeAvailability: function() {
      var html = "";

      return html;
    },
    abbreviate: function(str1) {
      var split_names = str1.trim().split(" ");
      if (split_names.length > 1) {
        return split_names[0] + " " + split_names[1].charAt(0) + ".";
      }
      return split_names[0];
    },
    lastUpdateSecondsAgo: function(l) {
      return (
        "(" +
        ((new Date().getTime() - l.getTime()).toFixed() / 1000).toFixed(0) +
        " seconds ago" +
        ")"
      );
    },
    formatLastUpdateTime: function(l) {
      //YYYY-MM-DD
      return "Last Update " + moment(l).format("HH:mm:ss");
    },
    closeCreateBookingDialog: function() {
      this.createBookingDialog = false;

      var vm = this;
      vm.$nextTick(function() {
        this.createBookingDialog = false;
        vm.$forceUpdate();
      });
    },
    bookingFromID: function(id) {
      return this.bookings.find(function(b) {
        return b.id == id;
      });
    },
    madeBooking: function() {
      this.createBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = null;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
    },
    updatedBooking: function() {
      this.editBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = null;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
    },
    cancelledBooking: function() {
      this.editBookingDialog = null;
      this.bookingForm = null;
      this.actionBoxMode = null;

      this.$refs.taxiMap.clear();
      this.$refs.taxiMap.recenter();
    },
    makeBookingLocationsChanged: function(val) {
      console.log("Updating map");
      this.$refs.taxiMap.zoomToMakingBooking(this.bookingForm.booking);
    },
    makeBooking: function() {
      console.log("Showing booking action box");

      this.bookingForm = new BookingForm(this.rideTypes, "", this.$store);

      this.actionBoxMode = "book";
    },
    cancel: function() {
      console.log("Hiding booking action box");
      this.actionBoxMode = null;
      this.bookingToAssign = null;
      this.bookingForm = null;

      this.loadingEditBooking = false;
      this.editBookingError = null;
    },
    enterAssignMode: function(b) {
      this.cancel();

      var vm = this;

      vm.$nextTick(function() {
        vm.actionBoxMode = "assign";
        vm.bookingToAssign = b;
      });
    },
    async enterEditMode(b) {
      this.cancel();

      var vm = this;

      this.loadingEditBooking = true;

      vm.$nextTick(async function() {
        vm.actionBoxMode = "edit";
        console.log("EDIT MODE ");

        var booking = await vm.getBookingForEdit(b);

        console.log("booking");
        console.log(booking);

        if (typeof booking === "string") {
          console.log("Error for edit booking");
          this.editBookingError = booking;
        } else {
          var bookingUser = BookingForm.jsonToBookingFormBookingUser(booking);

          this.bookingForm = new BookingForm(
            this.rideTypes,
            bookingUser,
            this.$store
          );
        }

        this.loadingEditBooking = false;
      });
    },
    setSelectedBooking: function(bookingID, taxiID) {
      if (bookingID != -1) {
        this.setSelectedTaxi(-1);
      }

      if (this.selectedBooking == bookingID) {
        console.log("resetting");
        this.selectedBooking = -1;
        return;
      } else {
        this.selectedBooking = bookingID;
      }

      console.log("Booking ID " + bookingID);
      console.log("Taxi ID " + taxiID);

      var taxi = null;

      if (taxiID != null) {
        taxi = this.taxis.find(function(t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          this.selectedTaxi = taxi.id;
          console.log("Got taxi " + this.selectedTaxi);
        }

        try {
          if (this.selectedTaxi != -1) {
            var elem = document.getElementById(this.selectedTaxi);
            elem.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest"
            });
          } else {
            var elem = document.getElementById("activeTable-header-row");
            elem.scrollIntoView(true);
          }
        } catch (e) {
          console.log(e);
          // taxi had no booking
        }
      }

      var booking = null;

      if (bookingID != -1) {
        booking = this.bookings.find(function(b) {
          return b.id == bookingID;
        });
      }

      if (booking == null) {
        console.log("Booking was null");
        return;
      }

      this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
      this.$refs.taxiMap.zoomToBookingTaxi(booking, taxi);
    },
    setSelectedTaxi: function(taxiID) {
      if (taxiID != -1) {
        this.setSelectedBooking(-1);
      }

      console.log(taxiID);

      if (this.selectedTaxi == taxiID) {
        this.selectedTaxi = -1;
      } else {
        this.selectedTaxi = taxiID;
      }

      try {
        if (this.selectedTaxi != -1) {
          var elem = document.getElementById(this.selectedTaxi);
          elem.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "nearest"
          });
        } else {
          var elem = document.getElementById("activeTable-header-row");
          elem.scrollIntoView(true);
        }
      } catch (e) {
        console.log(e);
        // taxi had no booking
      }

      try {
        // console.log(this);
        this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        this.$refs.taxiMap.zoomToTaxi(this.selectedTaxi);
      } catch (e) {
        console.log(e);
      }

      // highlight in table
      // highlight in summary
    },
    getInformation: async function() {
      this.loading = true;

      try {
        var url = `${this.$store.state.apiUrl}/overwatch/getInformation`;

        let response = await axios.get(url, {
          params: {}
        });

        // console.log(response.data);

        this.lastUpdateTime = new Date();

        this.taxis = response.data.taxis;
        this.bookings = response.data.jobs;

        this.rideTypeEtas = response.data.ride_type_eta;

        try {
          // console.log(this);
          this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        } catch (error) {
          console.log(error);
        }

        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 2000);
        }
      } catch (error) {
        this.loading = false;

        if (this.getInformationTimer != null) {
          setTimeout(this.getInformation.bind(this), 2000);
        }
        console.log("Failed to get information " + error);
      }
    },
    getCustomersForMap: async function() {
      // console.log("Getting customers for map");

      try {
        var url = `${this.$store.state.apiUrl}/customer_map/getInformation?inactivityCutoffSeconds=60`;

        let response = await axios.get(url, {
          params: {}
        });

        // console.log(response.data);

        this.customersForMap = response.data.customer_map_array;

        try {
          // console.log(this);
          this.$refs.taxiMap.updateMarkers(this.selectedTaxi);
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        this.loading = false;

        console.log("Failed to get customers for map " + error);
      }
    },
    getRideTypes: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/ride_types/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.rideTypes = response.data;

        console.log("got ride types");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    async getBookingForEdit(bookingID) {
      try {
        var url = `${this.$store.state.apiUrl}/booking/${bookingID}/get`;

        let response = await axios.get(url, {
          params: {}
        });

        this.loadingEditBooking = false;

        if (response.error == null || response.error == "no_error") {
          return response.data;
        } else {
          return response.data.error;
        }
      } catch (error) {
        this.loadingEditBooking = false;

        console.log("Failed to get booking " + error);
        return "Unknown Error";
      }
    }
  }
};
</script>
